import { TenantedClientApplicationSupportedByChoices } from "@graphql/generated/graphql.g";

import { Tag } from "@design-system/Tag/Tag";

type Props = {
  text?: TenantedClientApplicationSupportedByChoices | null;
};

export const SupportedByTag = ({ text }: Props) => {
  if (!text) {
    return null;
  }

  const colorMap: Record<
    TenantedClientApplicationSupportedByChoices,
    "danger" | "secondary" | "success" | "warning"
  > = {
    [TenantedClientApplicationSupportedByChoices.Msp]: "success",
    [TenantedClientApplicationSupportedByChoices.Client]: "warning",
    [TenantedClientApplicationSupportedByChoices.Vendor]: "secondary",
  };

  return <Tag color={colorMap[text]} text={text} />;
};
